module.exports = __webpack_public_path__ + "media/audio1.172efd4b.wav";